module.exports = __webpack_public_path__ + "static/media/QuickColored.c1c824e2.svg";